<template>
  <PrivacySection title="3. Dati Personali Raccolti">
    <p>
      I dati personali che raccogliamo e trattiamo includono:
    </p>
    
    <PrivacySubsection title="3.1 Dati Raccolti dall'Applicazione Mobile">
      <ul>
        <li><strong>Codice Fiscale:</strong> utilizzato esclusivamente per la generazione 
            del codice lotteria sul sito governativo della Lotteria degli Scontrini. 
            Il codice fiscale viene utilizzato solo per accedere al servizio governativo 
            e non viene memorizzato sui nostri server.</li>
        <li><strong>Codice Lotteria:</strong> memorizzato localmente sul dispositivo 
            dell'utente per facilitare l'accesso futuro al servizio governativo.</li>
        <li><strong>Dati Tecnici del Dispositivo:</strong> informazioni sul dispositivo 
            mobile utilizzato (tipo di dispositivo, sistema operativo, versione dell'app) 
            per garantire il corretto funzionamento dell'applicazione.</li>
      </ul>
    </PrivacySubsection>

    <PrivacySubsection title="3.2 Dati Raccolti dal Sito Web">
      <ul>
        <li><strong>Dati di Navigazione:</strong> informazioni raccolte automaticamente 
            durante la navigazione del sito web, inclusi indirizzo IP, tipo di browser, 
            pagine visitate, data e ora di accesso.</li>
        <li><strong>Cookie e Tecnologie Simili:</strong> utilizziamo cookie tecnici 
            necessari per il funzionamento del sito. Per maggiori informazioni, 
            consulta la sezione "Cookie" di questa Privacy Policy.</li>
        <li><strong>Dati Forniti Volontariamente:</strong> quando l'utente compila 
            il modulo di contatto, raccogliamo nome, indirizzo email, oggetto e messaggio 
            per rispondere alle richieste.</li>
      </ul>
    </PrivacySubsection>

    <PrivacySubsection title="3.3 Dati Non Raccolti">
      <p>
        Non raccogliamo né trattiamo:
      </p>
      <ul>
        <li>Dati di geolocalizzazione</li>
        <li>Dati biometrici</li>
        <li>Dati relativi a minori di 18 anni</li>
        <li>Dati di pagamento o finanziari</li>
      </ul>
    </PrivacySubsection>

    <PrivacySubsection title="3.4 Annunci pubblicitari (app mobile)">
      <p>
        L'app può mostrare banner pubblicitari tramite Google AdMob. Per utenti nello
        Spazio Economico Europeo, nel Regno Unito e in Svizzera, prima di mostrare annunci
        personalizzati chiediamo il consenso tramite il modulo Google User Messaging Platform
        (UMP), conforme al framework IAB TCF.
      </p>
      <p>
        <strong>Modifica o revoca del consenso:</strong> in qualsiasi momento apri
        <strong>Impostazioni → Privacy e dati → Preferenze annunci</strong> nell'app.
        Da lì puoi modificare o revocare le scelte sugli annunci personalizzati.
      </p>
      <p>
        <strong>Su iPhone/iPad:</strong> puoi anche gestire il tracciamento per annunci dalle
        impostazioni di sistema (Impostazioni → Privacy e sicurezza → Tracciamento).
      </p>
      <p>
        Per maggiori informazioni su come Google tratta i dati negli annunci, consulta le
        <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
          Norme sulla privacy di Google
        </a>.
      </p>
    </PrivacySubsection>
  </PrivacySection>
</template>

<script>
import PrivacySection from '../PrivacySection.vue'
import PrivacySubsection from '../PrivacySubsection.vue'

export default {
  name: 'DataCollectedSection',
  components: {
    PrivacySection,
    PrivacySubsection
  }
}
</script>

